<template>
  <div class="container permissions">
    <div class="mt-5">
      <h1 class="text-left mb-5">Permissions Groups</h1>

      <div class="mt-5 mb-5">
        <v-row no-gutters>
          <v-col class="text-right">
            <v-btn elevation="2" @click.stop="addNew">Add Group</v-btn>
          </v-col>
        </v-row>
      </div>

      <v-card>
        <v-card-title>
          Groups
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="permission"
          :items-per-page="100"
          :search="search"
          class="elevation-1 mt-5"
          @click:row="selectRow"
        ></v-data-table>
      </v-card>
    </div>

    <v-navigation-drawer floating right absolute temporary v-model="drawer">
      <v-container
        class="
          drawer-card
          d-flex
          space-between
          flex-column flex-md-row
          align-center
        "
      >
        <Table @cancel="cancel" @saved="saved" />
      </v-container>
    </v-navigation-drawer>
    <v-navigation-drawer floating right absolute temporary v-model="drawerEdit">
      <v-container
        class="
          drawer-card
          d-flex
          space-between
          flex-column flex-md-row
          align-center
        "
      >
        <Table :selectedItem="selectedItem" @cancel="cancel" @updated="updated"/>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
import permission from "./permission.controller.js";

export default {
  name: "Permissions",
  route: {
    name: "permissions",
    path: "/permissions",
  },
  components: {
    Table: () => import("./Table.vue"),
  },
  data() {
    return {
      drawer: false,
      drawerEdit: false,
      search: "",
      selectedItem: {
        roles: [
          {
            role: "Admin",
            selected: false,
          },
        ],
        organizations: [
          {
            organization: "Admin",
            selected: false,
          },
        ],
        name: "",
      },
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
      ],
      permission: [
        {
          roles: [
            {
              role: "Admin",
              selected: false,
            },
          ],
          organizations: [
            {
              organization: "Admin",
              selected: false,
            },
          ],
          name: "",
        },
      ],
    };
  },
  mounted() {
    this.getAll();
  },
  computed: {},
  methods: {
    selectRow(item) {
      this.selectedItem = item;
      this.drawerEdit = true;
    },
    async getAll() {
      this.permission = await permission.getAll();
    },
    addNew() {
      this.drawer = !this.drawer;
    },
    cancel() {
      this.drawer = false;
      this.drawerEdit = false;
    },
    saved() {
      this.drawer = false;
      this.getAll();
    },
    updated() {
      this.drawerEdit = false;
      this.getAll();
    },
  },
};
</script>

<style lang="scss">
.permissions {
  .v-navigation-drawer {
    position: fixed;
    width: 100% !important;
  }
  .v-overlay--active {
    position: fixed;
  }
}
</style>
